var _style, _polygon, _polygon2, _circle, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeasiblity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#82DDF0;}\r\n\t.st1{fill:#D3955E;}\r\n\t.st2{opacity:0.981;fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}\r\n\t.st3{opacity:0.991;fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}\r\n\t.st4{opacity:0.994;fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}\r\n\t.st5{opacity:0.962;fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}\r\n\t.st6{opacity:0.957;fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "456,495.6 51,495.6 51,15.5 358.5,15.5 413.8,74.5 456,114.6 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "428,124 349,124 349,31.5 401,74.5 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 255.4,
    cy: 347,
    r: 85.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.5-0.5c101,0,202,0,303,0c40.6,39.1,80.7,78.7,120.5,119c1.6,2.2,2.9,4.5,4,7c0.7,125,0.7,250,0,375 c-1.6,5.1-4.8,8.8-9.5,11c-139.3,0-278.7,0-418,0c-4.7-2.2-7.9-5.9-9.5-11c-0.7-163.3-0.7-326.7,0-490C38.6,5.4,41.8,1.7,46.5-0.5z  M67.5,29.5c87,0,174,0,261,0c-0.2,35.3,0,70.7,0.5,106c1.5,4.2,4.3,7,8.5,8.5c35.3,0.5,70.7,0.7,106,0.5c0,112.3,0,224.7,0,337 c-125.3,0-250.7,0-376,0C67.5,330.8,67.5,180.2,67.5,29.5z M358.5,52.5c20.8,20.3,41.5,40.8,62,61.5c-20.7,0.5-41.3,0.7-62,0.5 C358.5,93.8,358.5,73.2,358.5,52.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M106.5,59.5c61-0.2,122,0,183,0.5c8.4,4.3,11.2,11.2,8.5,20.5c-1.5,4.2-4.3,7-8.5,8.5c-61,0.7-122,0.7-183,0 c-9-5.2-11.5-12.7-7.5-22.5C101,63.6,103.5,61.3,106.5,59.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M106.5,119.5c61-0.2,122,0,183,0.5c8.4,4.3,11.2,11.2,8.5,20.5c-1.5,4.2-4.3,7-8.5,8.5c-61,0.7-122,0.7-183,0 c-9-5.2-11.5-12.7-7.5-22.5C101,123.6,103.5,121.3,106.5,119.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.5,179.5c99.3-0.2,198.7,0,298,0.5c9,5.2,11.5,12.7,7.5,22.5c-1.8,3-4.3,5.1-7.5,6.5 c-99.3,0.7-198.7,0.7-298,0c-9-5.2-11.5-12.7-7.5-22.5C101,183.6,103.5,181.3,106.5,179.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M240.5,243.5c50.5-4,87.4,16.3,110.5,61c18.6,50.5,7.4,93-33.5,127.5c-31.1,21-64.4,25.4-100,13 c-50.4-23.5-71.9-63-64.5-118.5c8.5-36.5,30-62,64.5-76.5C225.2,247.3,232.8,245.2,240.5,243.5z M254.5,273.5 c-15.3,0.8-29.3,5.7-42,14.5c-31.6,26.8-38.5,58.9-20.5,96.5c23.1,33.5,54,43.7,92.5,30.5c32.6-16.4,47.1-42.9,43.5-79.5 C318.6,297,294.1,276.3,254.5,273.5z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M278.5,314.5c17.7-0.8,23.9,7.2,18.5,24c-13.2,13.2-26.3,26.3-39.5,39.5c-6.3,3.3-12.7,3.3-19,0 c-8.2-8.2-16.3-16.3-24.5-24.5c-5.4-16.9,0.8-24.8,18.5-23.5c5.8,3.8,10.9,8.3,15.5,13.5C257.8,333.2,267.9,323.6,278.5,314.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeasiblity);
export default __webpack_public_path__ + "static/media/Feasiblity.a2ff6258ceb984bbd1b3c88d68fc8374.svg";
export { ForwardRef as ReactComponent };